import React from 'react';

import { Menu } from '~/components';

import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';

import { Session } from '~/components';

import { useAuth } from '~/hooks/authentication';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { data } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate === !!data.token ? (
          <Session isPrivate={isPrivate}>
            {isPrivate ? <Menu /> : null}
            {/* @ts-ignore */}
            <Component />
          </Session>
        ) : (
          <>
            <Redirect
              to={{
                pathname: isPrivate ? '/inicio' : '/pedidos',
                state: { from: location },
              }}
            />
          </>
        );
      }}
    />
  );
};

export default Route;
